export const TOKEN_NAME = 'IdToken';
export const SESSION_ID = 'SessionId';